import { render, staticRenderFns } from "./CommonDivider.vue?vue&type=template&id=5bd2a6f2&lang=pug&"
import script from "./CommonDivider.vue?vue&type=script&lang=ts&"
export * from "./CommonDivider.vue?vue&type=script&lang=ts&"
import style0 from "./CommonDivider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports